import * as React from 'react';

import {
  Button,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogOverlay,
} from '@rematter/ui-web';
import { LucideAlertTriangle } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

interface RegenerateSecretDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isRegenerating?: boolean;
}

export const RegenerateSecretDialog: React.FC<RegenerateSecretDialogProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  isRegenerating = false,
}) => {
  const t = useTranslations();

  const handleClose = () => {
    if (!isRegenerating) {
      onOpenChange(false);
    }
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <DialogOverlay
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      className="@RegenerateSecretDialog"
    >
      <DialogContent position="center" className="w-full min-w-[32rem]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl font-semibold text-warning">
            <LucideAlertTriangle className="size-5" />
            {t.dialogs.regenerateSecret.title}
          </DialogTitle>
        </DialogHeader>

        <div className="p-4">
          <p className="text-sm text-neutral/70">
            {t.dialogs.regenerateSecret.message}
          </p>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onPress={handleClose}
            isDisabled={isRegenerating}
          >
            {t.dialogs.regenerateSecret.cancel}
          </Button>
          <Button
            variant="solid"
            onPress={handleConfirm}
            isDisabled={isRegenerating}
            isLoading={isRegenerating}
          >
            {t.dialogs.regenerateSecret.confirm}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogOverlay>
  );
};
